import { ITrayFilterItemLocalized } from '../../../types';

/**
 * This function formats the tray filter list response by sorting the items
 */
export function formatTrayFilterListResponse(
  items: ITrayFilterItemLocalized[]
): ITrayFilterItemLocalized[] {
  return [...items].sort((a, b) => b.count - a.count);
}
